module.exports = __webpack_public_path__ + "static/media/02.d093ebd8.mp3";